import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

import { IJobStatus, IParamsGetJobStatus, IResponseGetJobStatus, IUpdatePosition } from '~/utils/interface/job-status';

const url = `api/admin/job-statuses`;

const jobStatusApi = {
  create(data: IJobStatus) {
    return axiosClient.post<IApiBaseResponse<IJobStatus>>(url, data);
  },
  getList(params: IParamsGetJobStatus) {
    return axiosClient.get<IApiBaseResponse<IResponseGetJobStatus>>(`api/admin/job-statuses`, { params });
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IJobStatus>>(`api/admin/job-statuses/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: IJobStatus) {
    return axiosClient.put<IApiBaseResponse<IJobStatus>>(`api/admin/job-statuses/${id}`, data);
  },
  updatePosition(id: string | undefined, data: IUpdatePosition) {
    return axiosClient.put<IApiBaseResponse<IJobStatus>>(`api/admin/job-statuses/position/${id}`, data);
  },
};

export default jobStatusApi;
